module.exports = __webpack_public_path__ + "components/flag/static/square/la-d88cb1713c89754fcb38f73483485bf2.svg";